// GamesFolder/TreeGames/TreeGame.js
import * as AllGames from "../index.js"; // this gives you access to BinaryTreeIntroduction, etc.

export const getListGame = (subcategory, stage) => {
    if (subcategory === "Singly Linked List") {
        switch (stage.name.toLowerCase()) {
            case "introduction":
                return <AllGames.SinglyLinkedListIntro />;
            case "insertion":
                return <AllGames.LinkedListInsertionGame />;
            case "deletion":
                return <AllGames.LinkedListDeletionGame />;
            case "searching":
                return <AllGames.LinkedListSearchGame />;
            default:
                return <p style={{ color: "black" }}>Παιχνίδι δεν βρέθηκε.</p>;
        }
    }
    else {
        switch (stage.name.toLowerCase()) {
            case "introduction":
                return <AllGames.DoublyLinkedListIntro />;
            case "deletion":
                return <AllGames.DoublyLinkedListDeletionGame />;
            case "searching":
                return <AllGames.DoublyLinkedListSearchGame />;
            case "insertion":
                return <AllGames.DoublyLinkedListInsertionGame />;
        }
    }

    return <p style={{ color: "black" }}>Δεν υποστηρίζεται αυτό το δέντρο.</p>;
};
